export default __webpack_public_path__ + "static/media/probabilityTicket.f00686de.png";